import React from "react";
import { useHistory } from "react-router-dom";
import { NavbarSpecialActions, NavContext } from "./NavContext";
import { TabsContext } from "./TabsContext";

interface Props {
  children: React.ReactNode;
}

export const NavProvider = (props: Props) => {
  const history = useHistory();
  const { currentTab, setCurrentTab } = React.useContext(TabsContext);
  const [navbarSpecialActions, setNavbarSpecialActions] =
    React.useState<NavbarSpecialActions>();

  const goBack = React.useCallback(() => {
    if (!history.location.state?.boundary) {
      history.goBack();
    } else if (history.location.pathname !== currentTab) {
      setCurrentTab(currentTab);
      history.replace(currentTab, {
        ...(history.location.state || {}),
        boundary: true,
      });
    }
  }, [history, currentTab, setCurrentTab]);

  const resetNavigationBoundary = React.useCallback(() => {
    history.replace(
      `${history.location.pathname}${history.location.search}${history.location.hash}`,
      { ...(history.location.state || {}), boundary: true }
    );
  }, [history]);

  const hasBack = React.useCallback(() => {
    return (
      !history.location.state?.boundary ||
      history.location.pathname !== currentTab
    );
  }, [history, currentTab]);

  const contextValue = React.useMemo(
    () => ({
      goBack,
      resetNavigationBoundary,
      hasBack,
      navbarSpecialActions,
      setNavbarSpecialActions,
    }),
    [
      goBack,
      resetNavigationBoundary,
      hasBack,
      navbarSpecialActions,
      setNavbarSpecialActions,
    ]
  );

  return (
    <NavContext.Provider value={contextValue}>
      {props.children}
    </NavContext.Provider>
  );
};
